import { sel, selAll } from '../utils'
export default function LinkMod() {
  const link$a = selAll('[data-mod]')
  if (link$a.length === 0) return //console.log('No link modals found')

  link$a.forEach((link$) => {
    const modId = link$.getAttribute('data-mod')
    // console.log('modId', modId)
    const modal$ = sel(`.mod-w.is--${modId}`)
    // console.log('modal$', modal$)
    if (!modal$) return console.log(`No modal found for id: #${modId}`)

    // gsap.set(modal$, { display: 'flex', opacity: 0 })
    // gsap.set(modal$, { opacity: 0, display: 'flex' })
    function modalInit(modal$) {
      if (modal$.tl) return
      const modalMod$ = modal$.sel('.mod')
      const modalX$ = modal$.selAll('.mod__x-w')
      const modalBg$ = modal$.selAll('.mod-bg')

      gsap.set(modal$, { display: 'flex', autoAlpha: 0 })

      modal$.tl = gsap
        .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
        //
        .to(modal$, { autoAlpha: 1 })
        .from(modalMod$, { y: 50 }, 0)
      ;[...modalX$, ...modalBg$].forEach((el) => {
        el.addEventListener('click', () => {
          // console.log('close modal')
          modal$.tl.reverse()
          // modTl.reverse().then(() => {
          //   // modal$.style.display = 'none'
          // })
        })
      })
    }
    modalInit(modal$)
    link$.addEventListener('click', (e) => {
      e.preventDefault()
      // console.log('open modal')
      modal$.tl.play()
    })
  })
}
